<!--
  ~ Developed for G.J. Gardner Homes by Softeq Development Corporation
  ~ http://www.softeq.com
  -->

<gh-ext-dialog layout="text" forBreakpoint="lt-xl">
  <gh-ext-dialog-header [title]="date | typeFormat:'DayMonthYear'"></gh-ext-dialog-header>
  <gh-ext-dialog-content>
    <div class="order" *ngFor="let order of orders">
      {{ order.purchaseOrder }}
    </div>
  </gh-ext-dialog-content>
  <gh-ext-dialog-button-bar align="center" class="buttons">
    <button type="button" mat-raised-button="" color="primary" class="large" (click)="onClose()">{{'lbl_show_calendar' | translate}}</button>
  </gh-ext-dialog-button-bar>
</gh-ext-dialog>